import { gsap } from 'gsap';

let loaderBar = document.querySelector('.loader--bar');

/**
 * Display given error in console
 * 
 * @param {String} output Text to display as error
 */
export function error(output) {
    console.error(output);
}

/**
 * Animate elements with stagger
 * 
 * @param {String} selector Selector CSS
 */
export function testGsap(selector) {
    if (document.querySelector(selector)) {
        gsap.from(selector, {duration: .4, opacity : 0, y : 50, rotate : 10, color : 'blue', stagger: 0.2});
    }
}
        

/**
 * Première partie de l'animation du loader,
 * qui sera utilisé au tout début du lancement de la page
 */
export function loaderBegin () {
    loaderBar.classList.add('begin');
}

/**
 * Deuxième partie de l'animation du loader,
 * qui sera utilisé lorsque la page sera chargé
 */
export function loader () {
    loaderBar.classList.add('half');
    setTimeout(() => {
        loaderBar.classList.add('finished');
        setTimeout(() => {
            document.getElementById('loader').classList.add('is-loaded');
        }, 500);
    },1500);
}

/**
 * templateURL
 */
export const templateURL = document.getElementById('templateURL').getAttribute('data-url');

